import React, { useState, useEffect } from "react";
import TabList from "../../components/List/tabList";
import Loading from "../../components/Common-components/loading";
import { apiGet } from "../../utils/api";
import { useSearchParams } from "react-router-dom";

export default function Tab() {
  const [searchResults, setSearchResults] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [showLoading, setShowLoading] = useState(false);
  const [searchParams] = useSearchParams();

  // 탭 데이터 로드
  useEffect(() => {
    const type = searchParams.get('type');
    
    const fetchTabs = async () => {
      let apiUrl = "";
      if (type === 'line') {
        apiUrl = "/navigation/get_line_tabs.php";
      } else { // 기본값 또는 region
        apiUrl = "/navigation/get_region_tabs.php";
      }

      try {
        const data = await apiGet(apiUrl);
        // console.log(data);
        setSearchResults(data);
      } catch (error) {
        console.error("탭 데이터 로딩 실패:", error);
      }
    };
    fetchTabs();
  }, [searchParams]);

  // 검색 실행
  // const handleSearch = async (searchParams) => {
  //   setIsLoading(true);
  //   setShowLoading(true);

  //   console.log("Search Params:", searchParams);

  //   try {
  //     const data = await apiGet("/search/get_search_products.php", searchParams);
  //     setSearchResults(data.results);
  //   } catch (error) {
  //     console.error("검색 에러:", error);
  //   } finally {
  //     setIsLoading(false);
  //     setTimeout(() => {
  //       setShowLoading(false);
  //     }, 500);
  //   }
  // };

  return (
    <>
      <TabList tabResults={searchResults} />
      {showLoading && <Loading isLoading={isLoading} />}
    </>
  );
}
